module.exports = __webpack_public_path__ + "static/media/ev26.d34a389c.JPG";